import { render, staticRenderFns } from "./ModalNewsletter.vue?vue&type=template&id=a313b726&"
import script from "./ModalNewsletter.vue?vue&type=script&lang=js&"
export * from "./ModalNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports